<script setup>
import PortalAuthShell from '@/Layouts/PortalAuthShell.vue'
</script>

<template>
  <PortalAuthShell portal="supplier">
    <slot />
  </PortalAuthShell>
</template>
